import styled from 'styled-components';

import { Menu as MUIMenu, MenuItem as MUIMenuItem } from '@mui/material';
import { colors } from 'spw-theme';

export const Menu = styled(MUIMenu)`
  && {
    .MuiPopover-paper {
      border-radius: 4px;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
  }
`;

export const MenuItem = styled(MUIMenuItem)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: ${colors.mainGray};
    img {
      margin-right: 8px;
    }
  }
`;
